import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useInboxMessages } from 'features/inboxMessages/hooks/useInboxMessages';
import { InboxMessage } from 'features/inboxMessages/inboxMessages.types';
import { InboxMessageContent } from 'features/inboxMessages/components/InboxMessageContent';

type ContentProps = {
  message: InboxMessage;
};

const Content = (props: ContentProps): JSX.Element => {
  const { message } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('messagesInbox.title')}</title>
      </Helmet>
      <InboxMessageContent message={message} />
    </>
  );
};

export const MessageDetail = (
  props: RouteComponentProps<{ messageId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { messageId },
    },
  } = props;
  const { messages, loading, error } = useInboxMessages();
  const { t } = useTranslation();

  const message = messages.find((msg) => msg.id.toString() === messageId);

  const status = getPageStatus({
    isLoading: loading,
    isError: error || !message,
  });

  return (
    <PageLayout
      data-cname="MessageDetailPage"
      status={status}
      headerBarProps={{
        title: t('messagesInbox.title'),
        action: status === 'ready' ? '/' : 'back',
      }}
    >
      {message && <Content message={message} />}
    </PageLayout>
  );
};
